export const appsAppGroupIdUserImportsImportIdScanEventNames =
  "/apps/:app_group_id/user_imports/:import_id/scan_event_names";
